var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _rect8, _circle, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriversLicenseBackOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 124,
    viewBox: "0 0 124 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3752_80907)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3752_80907)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.664 86.9775C113.664 88.2653 112.309 89.3096 110.637 89.3096L13.3584 89.3096C11.6866 89.3096 10.3312 88.2653 10.3311 86.9775L10.3311 38.5615C10.3313 36.4236 12.0641 34.6904 14.2021 34.6904L110.637 34.6904C112.309 34.6904 113.664 35.7346 113.664 37.0225L113.664 86.9775Z",
    fill: "url(#paint0_linear_3752_80907)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.3281,
    y: 47.9766,
    width: 103.333,
    height: 10.3333,
    fill: "black",
    fillOpacity: 0.54
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 20.6666,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -1.27572e-08 -5.19345e-06 1 16.2344 40.5957)",
    fill: "#83888E",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3683,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 16.2344 67.167)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 24.3683,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 16.2344 74.5479)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 29.2744,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -2.20797e-08 -3.00066e-06 1 16.2344 81.9287)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 24.4458,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 16.2344 70.8574)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 19.9783,
    height: 1.58928,
    rx: 0.794642,
    transform: "matrix(1 -3.3845e-08 -1.95756e-06 1 16.2344 78.2383)",
    fill: "#83888E",
    fillOpacity: 0.4
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.1
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.007 64.9521C105.918 64.9521 110.709 69.7436 110.709 75.6543C110.709 81.5651 105.918 86.3564 100.007 86.3564C98.365 86.3564 96.8103 85.9849 95.4199 85.3242C96.7488 84.6929 97.9251 83.7953 98.8838 82.7012C99.2497 82.759 99.6247 82.79 100.007 82.79C103.947 82.7899 107.142 79.5947 107.142 75.6543C107.141 71.7141 103.947 68.5197 100.007 68.5195C99.6251 68.5195 99.2503 68.5497 98.8848 68.6074C97.9259 67.5129 96.7491 66.6148 95.4199 65.9834C96.8102 65.3228 98.3652 64.9522 100.007 64.9521ZM91.9551 68.6074C93.2617 68.8138 94.4499 69.3754 95.4189 70.1895C93.8613 71.4983 92.8712 73.4608 92.8711 75.6543C92.8711 77.8478 93.8623 79.8091 95.4199 81.1182C94.4506 81.9329 93.2623 82.4946 91.9551 82.7012C90.3059 80.8184 89.3047 78.3539 89.3047 75.6543C89.3047 72.9548 90.3059 70.4902 91.9551 68.6074Z",
    fill: "black",
    fillOpacity: 0.6
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97266 109.895H13.3721V110.962H5.90625V103.496H6.97266V109.895ZM117.358 110.962H109.893V109.895H116.292V103.496H117.358V110.962ZM13.3721 14.4404H6.97266V20.8398H5.90625V13.374H13.3721V14.4404ZM117.358 20.8398H116.292V14.4404H109.893V13.374H117.358V20.8398Z",
    fill: "#1FACB1"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: 70.8601,
    y: 88.5711,
    width: 35.4282,
    height: 35.4282
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(1.48px)",
      clipPath: "url(#bgblur_1_3752_80907_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 2.95238,
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619,
    fill: "#9AE5E7",
    fillOpacity: 0.2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 88.5751,
    cy: 106.285,
    r: 11.8095,
    fill: "#04BEC4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4541 103.112C94.6944 103.879 93.9375 104.629 93.1779 105.375C91.4546 107.069 89.731 108.763 88.0043 110.454C87.8063 110.648 87.5846 110.795 87.2929 110.859C86.8539 110.955 86.4838 110.835 86.1881 110.549C84.8611 109.265 83.548 107.968 82.234 106.671C81.933 106.375 81.8375 105.793 82.0282 105.401C82.2359 104.975 82.5688 104.731 83.0742 104.706C83.5115 104.685 83.8426 104.865 84.1324 105.148C85.105 106.097 86.0727 107.052 87.0457 108.008C89.2507 105.842 91.4519 103.676 93.6567 101.514C94.1691 101.012 94.8832 100.976 95.4189 101.471C95.8606 101.878 95.9138 102.654 95.4541 103.112Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3752_80907",
    x: -16.7725,
    y: 13.3971,
    width: 149.794,
    height: 101.077,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3.87152,
    dy: 1.93576
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11.6146
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.239216 0 0 0 0 0.392157 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3752_80907"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3752_80907",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_1_3752_80907_clip_path",
    transform: "translate(-70.8601 -88.5711)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 73.8125,
    y: 91.5234,
    width: 29.5238,
    height: 29.5238,
    rx: 14.7619
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3752_80907",
    x1: 12.4911,
    y1: 63.0736,
    x2: 145.541,
    y2: 52.085,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9D1DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607628,
    stopColor: "#DAE2EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF0F7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3752_80907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversLicenseBackOk);
export default __webpack_public_path__ + "static/media/DriversLicenseBackOk.4bee5ffc0e1311b5e80fa9836385d298.svg";
export { ForwardRef as ReactComponent };